import OnProcessStrategies from "../OnProcessStrategies"

function Existing() {
  return (
    <OnProcessStrategies/>
    
  )
}

export default Existing